"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.history = void 0;
var history_1 = require("history");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_router_1 = require("react-router");
// import Admin from './admin/index';
var dashboard_1 = require("./dashboard");
var index_1 = require("./error/index");
var index_2 = require("./index/index");
var SiteHeader_1 = require("../components/common/SiteHeader");
var SiteFooter_1 = require("../components/common/SiteFooter");
var NavigationDrawer_1 = require("../components/common/NavigationDrawer");
var TermsAndConditionsModal_1 = require("../components/TermsAndConditions/TermsAndConditionsModal");
// import SelfSignup from './selfSignUp';
var Admin = React.lazy(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, Promise.resolve().then(function () { return require('./admin/index'); })];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); });
exports.history = (0, history_1.createBrowserHistory)();
var Router = function (props) {
    var _a = __read(React.useState(false), 2), tCModalOpen = _a[0], setTCModalOpen = _a[1];
    return (React.createElement(React.Suspense, { fallback: React.createElement("div", null, "Loading") },
        React.createElement(react_router_dom_1.BrowserRouter, { future: { v7_startTransition: true, v7_relativeSplatPath: true } },
            React.createElement(SiteHeader_1.default, { toggleMenu: props.toggleMenu }),
            React.createElement("div", { className: "site-body" },
                React.createElement(react_router_1.Routes, null,
                    React.createElement(react_router_1.Route, { path: "/admin/*", element: React.createElement(Admin, null) }),
                    React.createElement(react_router_1.Route, { path: "/error", element: index_1.default }),
                    React.createElement(react_router_1.Route, { path: "/dashboard/*", element: React.createElement(dashboard_1.default, { setTCModal: setTCModalOpen }) }),
                    React.createElement(react_router_1.Route, { path: "/", element: React.createElement(index_2.default, null) }))),
            React.createElement(NavigationDrawer_1.default, { menuOpen: props.menuOpen, toggleMenu: props.toggleMenu }),
            React.createElement(TermsAndConditionsModal_1.default, { modalOpen: tCModalOpen, setModalOpen: setTCModalOpen }),
            React.createElement(SiteFooter_1.default, { setModalOpen: setTCModalOpen }))));
};
exports.default = Router;
